{
  "pointsPerInteraction": 1,
  "playerSpeedPxPerSec": 220
}
